import React from "react";

import { IconGridBlock as Value } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { RichText } from "../RichText";

import styles from "./index.module.scss";

interface Props {
    value: Value;
    id?: string;
}

export const IconGridBlock = ({ value, id }: Props) => {
    if (!value.items || value.items.length === 0) return <></>;

    return (
        <div className={styles.root}>
            {value.items.map((item, index) => (
                <div
                    key={`${id}-${index}`}
                    className={
                        item.override_icon_color
                            ? styles.itemOverrideColor
                            : styles.item
                    }
                >
                    {item.image && (
                        <ImageChooserBlock
                            value={item.image}
                            sizes="(max-width: 767px) 80px, 120px"
                            attrs={{ className: styles.picture }}
                            imageAttrs={{ className: styles.image }}
                        />
                    )}
                    {item.heading && (
                        <h3 className={styles.heading}>{item.heading}</h3>
                    )}
                    {item.body && (
                        <RichText
                            className={styles.body}
                            value={item.body}
                            textAlignment="center"
                        />
                    )}
                </div>
            ))}
        </div>
    );
};
